<template>
  <div id="db-products">
    <!--
            <div class="product-view" v-for="product in parentData.products" v-bind:key="product.name" :product-id="product.id" @click="setValue(product.id)" :class="{active: isSelected(product.id)}">
                <strong class="title">{{ product.name }}</strong>
                <img v-bind:src="product.image" />
                <div class="price"><strong>Preis: {{ localizePrice(product.price) }} &euro; </strong>
                    <small class="ppu"> (p.p. {{product.vp_unit}} {{ localizePrice(getPricePerUnit(product.price, product.vp)) }})</small>
                </div>
                <div class="vp"><small>Verpackungseinheit: {{ product.vp }} {{ product.vp_unit }}</small></div>
                
                <ul class="attributes">
                    <li v-for="(attribute, index) in product.attributes" v-bind:key="index">{{ attribute }}</li>
                </ul>
            </div>
        -->
    <div style="text-align: center;">
      <div
        v-for="(group, i) in productGroups"
        v-bind:key="i"
        style=""
        @click="setValue(group.linkToValue)"
        v-bind:id="'label' + group.linkToValue"
        v-show="isVisible(i)"
        class="productgroup-entry"
      >
        <div class="productgroup-image" v-if="group.img">
          <img v-bind:src="group.img" class="productgroup-image" />
        </div>
        <div class="productgroup-title">{{ group.name }}</div>
        <div class="productgroup-desc" v-if="group.desc">{{ group.desc }}</div>
        <div class="productgroup-priceperunit">{{ group.pricePerUnit }}</div>
        <div class="productgroup-checklist" v-if="group.checklist">
          <ul>
            <li v-for="(check, i) in group.checklist" v-bind:key="i">
              {{ check }}
            </li>
          </ul>
        </div>
        <div class="productgroup-checkbox">
          <img
            v-bind:src="
              currentValue === group.linkToValue
                ? '/img/checkbox_true.jpg'
                : '/img/checkbox_false.jpg'
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      parentData: this.$parent._data,
      selectedProduct: null,
    };
  },

  computed: {
    productGroups() {
      return JSON.parse(this.parentData.productGroups);
    },

    currentValue() {
      return this.parentData.question.value;
    },
  },

  methods: {
    isVisible(i) {
      return this.parentData.question.choices[i].isVisible;
    },

    setValue(id) {
      this.selectedProduct = id;
      this.parentData.question.surveyValue.setValue(
        this.parentData.question.name,
        id
      );
    },

    getValue() {
      return this.parentData.question.value;
    },

    isSelected(id) {
      return (
        this.selectedProduct === id ||
        (this.selectedProduct === null && this.parentData.question.value === id)
      );
    },

    getPricePerUnit(price, vp) {
      return (Math.round((price / vp) * 1000) / 1000).toFixed(3);
    },

    localizePrice(price) {
      return price.toString().replace(/\./g, ",");
    },
  },
};
</script>

<style scoped>
/*
#db-products {
  width: 100%;
  max-width: 100%;
  display: flex;
}

#db-products > div > div {
  cursor: pointer;
}

.product-view {
  margin: 10px;
  padding: 10px;
  background-color: #f3f3f3;
  border: 2px solid #f3f3f3;
}

.product-view:hover {
  border: 2px solid #e3e3e3;
}

.product-view.active,
.product-view.active:hover {
  border: 2px solid #008035;
}

.product-view img {
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
  display: block;
}

.price {
  margin-top: 10px;
}

.title {
  margin-bottom: 10px;
}

ul.attributes {
  margin-top: 20px;
  padding-left: 0px;
}

ul.attributes li {
  font-size: 90%;
  list-style: none;
}

ul.attributes li:before {
  content: "\2713  ";
  font-weight: bold;
  color: #008035;
}

.productgroup-title {
  text-align: center;
  font-weight: bold;
  color: #000;
  text-transform: uppercase;
  font-family: "Work Sans", sans-serif;
  font-size: 1.5rem;
}




.productgroup-desc {
  color: #000;
  padding: 10px 65px;
  text-align: center;
}

.productgroup-checkbox {
  text-align: center;
}

.productgroup-entry {
  text-align: center;
  display: block;
  width: 100%;
  margin-bottom: 20px;
}
.productgroup-image {
  max-width: 100%;
}

@media(min-width: 768px) {
  .productgroup-entry {
    text-align: center;
    display: inline-block;
    width: 50%;
    margin-bottom: 20px;
  }
}
@media(min-width: 1200px){
  .productgroup-title {
    font-size: 2rem;
  }
}
*/
</style>
